'use client';

import React, { useEffect } from 'react';
import Intercom from '@intercom/messenger-js-sdk';
import { ClientConfig } from '@/core/client-config';
export const IntercomContainer = ({
  enabled
}: {
  enabled?: boolean;
}) => {
  useEffect(() => {
    if (enabled && ClientConfig.intercom.appId) {
      Intercom({
        app_id: ClientConfig.intercom.appId,
        hide_default_launcher: true,
        custom_launcher_selector: '#intercom-launcher'
      });
    }
  }, [enabled]);
  return <></>;
};